import whatsappIcon from "../images/whatsapp.png";
import mailIcon from "../images/jobMail.png";
import slackIcon from "../images/slack.png";
import telegramIcon from "../images/telegram.png";
import SmsIcon from "../images/chatting.png";
import printIcon from "../images/printer.png";
import addCartIcon from "../images/add-to-cart.png";
import clearCartIcon from "../images/clear-cart.png";
import cartWishListIcon from "../images/wishlist.png";
import activityOwnerAssignment from "../images/OwnerAssigment.png";
import editAppUser from "../images/personalization.png";
import navigate from "../images/navigation (1).png";
import showPopup from "../images/showPopup.png";
import navigateMapped from "../images/NavigateMapped.png";
import debugInstance from "../images/debugging.png";
import deleteInstance from "../images/remove.png";
import emailPdf from "../images/mail.png";
import processDocx from "../images/process.png";
import excelDocx from "../images/xls.png";
import performActivityAi from "../images/AI.png";
import StartSm from "../images/startstatemachine.png";
import scheduleActivity from "../images/schedule activity bg.png";
import editEntity from "../images/editEntity.png";
import performActivity from "../images/perform activity.png";
import rdbmsInsert from "../images/RdbmsInsert.png";
import rdbmsUpdate from "../images/rdbmsUpdate.png";
import editSm from "../images/editSm.png";
import customJS from "../images/customjs.png";
import mangoJoins from "../images/mangoJoins.png";
import todoList from "../images/todoList.png";
import procodeIcon from "../images/procode.png";
import navigateBackIcon from "../images/navigate back.png";
import createPaymentIcon from "../images/create payment.png";
import ocrIcon from "../images/ocr.png";
import postgreIcon from "../images/postgres.png";
import refreshPageIcon from "../images/refresh-page.png";
import registerAppUserIcon from "../images/register app.png";
import textNotificationIcon from "../images/text notification.png";
import vapiVoiceAiIcon from "../images/vapi voice call.png";
import editEntityIcon from "../images/edit entity bg.png";
import editSelfEntityIcon from "../images/edit self entity.png";
import EditLinkedSmIcon from "../images/Edit SM.png";
import editSmByFilterIcon from "../images/Edit sm by filter bg.png";
import gridToSmIcon from "../images/grid to sm.png";
import smToGridIcon from "../images/sm to grid.png";
import performSapIcon from "../images/perform sap operation.png";
// import removeCommunityUserIcon from "../images/remove community user.png";
import startSmOfflineIcon from "../images/start sm offline.png";
// import updateCommunityUserIcon from "../images/update community user.png";
// import addCommunityUserIcon from "../images/add community user.png";
import showDvInRowIcon from "../images/show dv in row.png";
import performTimelineAiIcon from "../images/perform timeline ai.png";
import performActivityAgentAiIcon from "../images/perform activity agent ai.png";
import showRvinRowIcon from "../images/show rv in row.png";
import makeCallIcon from "../images/make call.png";
import HTTPRequest from "../images/http.png";
import GlobalVariable from "../images/global.png";
import AddUser from "../images/addUser.png";
import RemoveUser from "../images/removeUser.png";
import PrefillForm from "../images/form.png";

const jobIcons = {
  send_whatsapp_bg: whatsappIcon,
  send_sms_bg: SmsIcon,
  send_telegram_msg_bg: telegramIcon,
  send_slack_msg_bg: slackIcon,
  send_email_bg: mailIcon,
  print_detailsview: printIcon,
  print_detailsview_bg: printIcon,
  add_or_update_cart: addCartIcon,
  clear_cart_items: clearCartIcon,
  add_wishlist: cartWishListIcon,
  set_owner: activityOwnerAssignment,
  get_edit_app_user_form: editAppUser,
  navigate: navigate,
  show_detailsview_popup: showPopup,
  navigate_with_mapped: navigateMapped,
  debug_instance: debugInstance,
  delete_instance: deleteInstance,
  make_html_to_pdf: emailPdf,
  send_google_doc: processDocx,
  send_excel_doc: excelDocx,
  perform_activity_ai: performActivityAi,
  start_state_machine_bg: StartSm,
  start_state_machine: StartSm,
  edit_entity_fe: editEntity,
  edit_entity_plus_fe: editEntity,
  schedule_activity_bg: scheduleActivity,
  perform_activity_bg: performActivity,
  perform_activity: performActivity,
  set_owner_bg: activityOwnerAssignment,
  navigate_device: navigate,
  register_entity_bg: editEntity,
  rdbms_insert: rdbmsInsert,
  rdbms_update: rdbmsUpdate,
  custom_js: customJS,
  mongo_template_insert: mangoJoins,
  edit_sm_bg: editSm,
  edit_appuser_fields: editAppUser,
  add_todo: todoList,
  edit_parent_sm_bg: editSm,
  execute_pro_code: procodeIcon,
  navigate_back: navigateBackIcon,
  create_payment: createPaymentIcon,
  ocr: ocrIcon,
  postgres_insert: postgreIcon,
  postgres_update: postgreIcon,
  refresh_page: refreshPageIcon,
  register_app_user: registerAppUserIcon,
  text_notification: textNotificationIcon,
  vapi_voice_ai: vapiVoiceAiIcon,
  edit_entity_bg: editEntityIcon,
  edit_self_entity_bg: editSelfEntityIcon,
  edit_linked_sm_bg: EditLinkedSmIcon,
  edit_sm_by_filter_bg: editSmByFilterIcon,
  grid_to_sm_bg: gridToSmIcon,
  sm_to_grid_fe: smToGridIcon,
  perform_sap_operation: performSapIcon,
  // remove_community_user_to_group: removeCommunityUserIcon,
  start_state_machine_offline: startSmOfflineIcon,
  // update_community_user_fields: updateCommunityUserIcon,
  // add_community_user_to_group: addCommunityUserIcon,
  // create_community_user: addCommunityUserIcon,
  // update_community_user: updateCommunityUserIcon,
  show_detailsview_in_row: showDvInRowIcon,
  perform_timeline_ai: performTimelineAiIcon,
  perform_activity_agent_ai: performActivityAgentAiIcon,
  show_recordsview_in_row: showRvinRowIcon,
  perform_activity_rdbms_fe: performActivity,
  show_recordsview_popup: showRvinRowIcon,
  register_entity: editEntity,
  send_email_fe: mailIcon,
  make_call_fe: makeCallIcon,
  // get_add_app_user_form: addCommunityUserIcon,
  register_entity_offline: editEntity,
  make_http_request: HTTPRequest,
  set_global_variables: GlobalVariable,
  add_user_to_group: AddUser,
  remove_user_from_group: RemoveUser,
  prefill_form: PrefillForm
};

export const getJobIcon = (jobTemplate) => {
  return jobIcons[jobTemplate];
};
